import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TranslationProvider } from './hooks/useTranslations';
import { HomePage } from './pages/HomePage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { RefundPage } from './pages/RefundPage';
function App() {
  useEffect(() => {
    // Meta Pixel Code
    ;
    (function (f: any, b: any, e: string, v: string, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if script tag exists, insert before it; otherwise append to head
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize Meta Pixel with new ID
    if (window.fbq) {
      window.fbq('init', '2761166727550118');
      window.fbq('track', 'PageView');
    }
    // LeadConnector Chat Widget
    const widgetId = '6a240ccded0ee22f92081f38';
    if (!document.querySelector(`script[data-widget-id="${widgetId}"]`)) {
      const widgetScript = document.createElement('script');
      widgetScript.src = 'https://beta.leadconnectorhq.com/loader.js';
      widgetScript.setAttribute('data-resources-url', 'https://beta.leadconnectorhq.com/chat-widget/loader.js');
      widgetScript.setAttribute('data-widget-id', widgetId);
      widgetScript.async = true;
      document.body.appendChild(widgetScript);
    }
  }, []);
  return <TranslationProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-6" />} data-id="element-5" />
          <Route path="/terms" element={<TermsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/refund" element={<RefundPage data-id="element-10" />} data-id="element-9" />
        </Routes>
      </Router>
      {/* Meta Pixel Noscript Fallback */}
      <noscript data-id="element-11">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2761166727550118&ev=PageView&noscript=1" alt="" data-id="element-12" />
      </noscript>
    </TranslationProvider>;
}
export { App };